import {
  Backdrop,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CircularProgress,
  Divider,
  GridList,
  GridListTile,
  GridListTileBar,
  IconButton,
  Modal,
  Dialog
} from '@material-ui/core';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'src/utils/axios';
import { openBlob } from 'src/utils/Common';
import { useDispatch, useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  rootCCFile: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 700,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  actionsCCFile: {
    justifyContent: 'flex-end'
  }
}));

function CCFilePopup({ open, onClose, ReceiptNo, className }) {
  const classes = useStyles();
  const { t } = useTranslation('common');
  const locale = localStorage.getItem('i18nextLng');
  const [loading, setLoading] = useState(false);
  const [CCFileData, setCCFileData] = useState([]);
  const [uyariTip, setUyariTip] = React.useState('error');
  const [uyari, setUyari] = useState(false);
  const dispatch = useDispatch();
  const [ImageUrl, setImageUrl] = useState('');
  const [ImagePopup, setImagePopup] = useState(false);
  const getFilesForSF = async () => {
    axios.get(`/SfMainFile/${ReceiptNo || 0}`)
    .then(response => {
      if(response.data.length > 0 && response.data != ""){
        dispatch(setCCFileData(response.data));
        setLoading(false);
      }else{
        setCCFileData([]); //no data
      }
    })
    .catch(error => {
      setUyariTip('error');
      setUyari(true);
    });
  }
  useEffect(() => {
    getFilesForSF();
  }, [locale]);
  
  const handleCCFileDetayAc = (event, Id, Type,Name) => {
    setLoading(true);
    const config = {
      responseType: 'blob'
    };
    axios
        .get(`/SfFileDetail/${ReceiptNo}/${Id}/${Type}`, config)
        .then(response => {
          openBlob(response.data, Id+Name);
          // const fileURL = URL.createObjectURL(response.data);
          // newWindow.location = fileURL;
          // newWindow.document.title = dosya.FileName;
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
        });
    
  };

  if (!open) {
    return null;
  }

  return (
    <Modal
      onClose={() => {
        onClose();
      }}
      open={open}
    >
      <Card className={clsx(classes.rootCCFile, className)}>
        <CardHeader title={t('Cagri_Merkezi_Dosyalar')} />
        <CardContent className={classes.content}>
          {loading ? (
            <Backdrop className={classes.backdrop} open={loading}>
              <CircularProgress color="inherit" />
            </Backdrop>
          ) : (
            ''
          )}
          <GridList cellHeight={120} className={classes.gridList}>
            {CCFileData.map(item => (
              <GridListTile key={item.AttachmentId}>
                <IconButton
                  onClick={event =>
                    handleCCFileDetayAc(
                      event,
                      item.AttachmentId,
                      item.ObjectType,
                      "."+item.ContentType
                    )
                  }
                  aria-label={`büyük resim ${item.Name}`}
                >
                  <PhotoLibraryIcon />
                </IconButton>
                
                <GridListTileBar
                  title={item.Name}
                  subtitle={<span>{item.ContentType}</span>}
                />
              </GridListTile>
            ))}
          </GridList>
        </CardContent>
        <Divider />
        <CardActions className={classes.actionsCCFile}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              onClose();
            }}
          >
            {t('Kapat')}
          </Button>
        </CardActions>
        <Dialog
              open={ImagePopup}
              fullWidth
              maxWidth="sm"
              onClose={() => setImagePopup(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <img width="auto" height="auto" src={ImageUrl} style={{ border: 'none' }} onclick={() => setImagePopup(false)}></img>
            </Dialog>
      </Card>
    </Modal>
    
  );
}

CCFilePopup.defaultProps = {
  open: false,
  onClose: () => {}
};

export default CCFilePopup;
